import DeleteModal from "components/Common/DeleteModal";
import TableContainerV1 from "components/Common/TableContainerV1";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import { useFormik } from "formik";
import { decryptedValue, isPermission } from "common/utility";
import { getDropDownStates } from "http/fundLync/dropdown.helper";
import { getAuthorisedPersonList, getPersonAddress, callGetCity, callGetState, getCrifReport, editAuthorisedPerson, addCrifReport, getCrifReportList, deleteCrifReportList, getCrifReportCommercial, getOneEntity, stage2Question, getUserConsent } from "http/fundLync/entityAndAddress.helper";
import {
  callBureauLists,
} from "http/fundLync/entityDocuments.helper";
import {addUser} from "http/fundLync/user.helper";
import { downloadSystemConfigFile } from "../../http/UAM/systemConfig.helper";
import moment from "moment";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import {
  Col, Form, FormFeedback, Input, Label, Modal,
  ModalHeader, Row, Button
} from "reactstrap";
import * as Yup from "yup";
import { getDropDownList } from "../../http/fundLync/dropdown.helper";
import { callGetGSTINDetails } from "http/gstin/gstin";
import { useAsyncDebounce } from "react-table";
import CommonDialog from "components/Common/CommonDialog";

const TableActionsComponent = (deleteClickFn, viewClickFn) => {


  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <i
        title="Delete"
        className="mdi mdi-delete action-icon"
        onKeyUp={() => { }}
        onClick={() => {
          deleteClickFn()

        }}
      ></i>
    </div>
  )
}

const TableFileComponent = (value, isPendingFile, fileDownloadFn) => {
  if (value && !isPendingFile) {
    return (
      <i
        className="mdi mdi-file-download-outline action-icon"
        onClick={fileDownloadFn}
        onKeyUp={() => { }}
      ></i>
    );
  } else if (isPendingFile) {
    return <span>Pending</span>;
  } else {
    return <></>;
  }
};

const CreditVerification = ({customActiveTab}) => {
  document.title = "Credit Verification | FundLync";
  const urlParams = new URLSearchParams(window.location.search);
  
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')

  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [selectedBureauFor, setSelectedBureauFor] = useState(null);
  const [authPersonList, setAuthPersonList] = useState(null);
  const [selectedAuthPerson, setSelectedAuthPerson] = useState(null);
  const [selectedBureauForData, setSelectedBureauForData] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const [bureauForOptions, setBureauForOptions] = useState([]);
  const [idList, setIdList] = useState([]);
  const currentDate = new Date().toISOString().split("T")[0];
  const [tableData, setTableData] = useState([]);
  const [columnId, setColumnId] = useState("id");
  const [isGSTINSerching, setGSTINSerching] = useState(false);
  const pagination = {
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  }
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [dialogObj, setDialogObj] = useState();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ansSubmitting, setAnsSubmitting] = useState(false);
  const [tableSortingOptions, setTableSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action", "consentFor", "submittedBy", "submittedAt", "pdfCrifReport"],
  });
  const [view, setView] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [address, setAddress] = useState([])
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [entityDetail, setEntityDetail] = useState([]);
  const [subscribemodal, setSubscribemodal] = useState(false);
  const [question, setQuestion] = useState('false');
  const [optionsList, setOptionsList] = useState([]);
  const [responseBody, setResponseBody] = useState([]);
  const [selectedState, setSelectedState] = useState({});
  const [loadingCom, setLoadingCom] = useState(false);
  const [isUserConsentPermission, seIisUserConsentPermission] = useState(false);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [showCommonDialog2, setShowCommonDialog2] = useState({ isShow: false });
  const [cityForCompany, setCityForCompany] = useState({});



  const valueName = {
    PAN: 'pan',
    UID: 'adharNo',
    VOTERID: 'voterId',
    PASSPORT: 'passportNo',
    RATION: 'rationCardNo',
    NREGA: 'nregaNo',
    CKYC: 'ckyc',
    'DRIVING LICENSE': 'drivingLicense',
  }

useEffect(() => {
  fetchData();
  if(entityId){
    loadBureauList();
    callCrifReportList();
  }
  setBureauForOptions([{ label: 'Individual', value: 'Individual' }, { label: 'Commercial', value: 'Commercial' }]);
  checkPermissions();
}, [customActiveTab,entityId]);

useEffect(() => {
  callGetState()
    .then((response) => {
      if (response.code == "200") {
        setStateList(response.data);
      }
    })
    .catch((error) => { });
    getDropDownList({ dropdownName: "id_type" }).then(
      (response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) => dv.dropdownName == "id_type"
          )?.dropdownValues || [];
        const formattedOptions = dropdownValues.map((option) => ({
          label: option.displayName,
          value: option.dropdownValue,
        }));
        setIdList(formattedOptions);
      }
    ).catch((error) => { });
    checkPermissions()
  }, [entityId]);

  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
      checkPermissions()
}, []);
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])

  useEffect(() => {
    if (!entityId) return;
    getOneEntity({ entityId })
      .then((response) => {
        if (response.status) {
          setEntityDetail(response.data[0]);
        }
      })
      .catch((error) => {
        console.error(error);
      });

  }, [entityId]);

  const callCrifReportList = () => {
    getCrifReportList({ entityId, columnName: columnId, sortingOrder: sortingOrderStatus })
      .then((response) => {
        if (response.code == "200") {
          if (response.status) {
            setTableData(response.data.data);
          } else {
            setTableData([]);
          }
        }
      })
      .catch((error) => { });
  }

  const columns = useMemo(
    () => [
      {
        Header: "Consent For",
        accessor: "consentFor",
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          if (rowData.type == "Commercial") {
            return rowData.entity.entityName;
          }
          return rowData.authPerson.first_name + ' ' + rowData.authPerson.last_name || "";
        },
      },
      {
        Header: "Submitted By",
        accessor: "submittedBy",
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return rowData.submittedByUser.first_name + ' ' + rowData.submittedByUser.last_name || "";
        },
      },

      {
        Header: "Fetched Score",
        accessor: "fetchedScore",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },

      {
        Header: "Submitted At",
        accessor: "submittedAt",
        filterable: true,
        Cell: (cellProps) => {
          return moment(cellProps.value).format("DD-MM-YYYY") || "";
        },
      },

      {
        Header: "Bureau Report File",
        accessor: "pdfCrifReport",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value, !cellProps.value, () => {
            formatFunction(cellProps.value, handleToast);
          });
        },
      },
      {
        Header: "Type",
        accessor: "type",
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
            return rowData.type || 'Individual';
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(() => {
            setDialogObj(rowData);
            setDeleteDialog(true);
          }, () => {
          });
        },
      },
    ],
    []
  );

  const fetchData = async () => {
    try {
      const res = await getAuthorisedPersonList({ entityId });
      const states = await getDropDownStates();
      setAuthPersonList(res?.data?.data);
      setStateOptions(states?.data);
      if(entityId){
      loadBureauList();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const loadBureauList = async () => {
    const postParams = {
      entity_id: entityId,
      type: "crif",
    };
    callBureauLists(postParams)
      .then((response) => {
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const validationTypePartner = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: selectedBureauForData?.firstName || "",
      lastName: selectedBureauForData?.lastName || "",
      identy: "",
      dob: moment(selectedBureauForData?.dob).format("YYYY-MM-DD") || "",
      PAN: selectedBureauForData?.pan || "",
      UID: selectedBureauForData?.adharNo || "",
      VOTERID: selectedBureauForData?.voterId || "",
      PASSPORT: selectedBureauForData?.passportNo || "",
      RATION: selectedBureauForData?.rationCardNo || "",
      NREGA: selectedBureauForData?.nregaNo || "",
      CKYC: selectedBureauForData?.ckyc || "",
      'DRIVING LICENSE': selectedBureauForData?.drivingLicense || "",
      email: selectedBureauForData?.email || "",
      phone: selectedBureauForData?.mobile || "",
      address: address[0]?.address1 || "",
      city: address[0]?.city || "",
      state: address[0]?.state || "",
      pin: address[0]?.pincode || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Applicant First Name is required"),
      lastName: Yup.string().required("Applicant Last Name is required"),
      identy: Yup.string().required("Please Select Id"),
      dob: Yup.string().required("Date of Birth is required"),
      email: Yup.string().required("Email is required"),
      PAN: selectedId?.value == 'PAN'
        ? Yup.string()
          .matches(API_SERVICES.PAN_PATTERN, "Enter valid PAN pattern")
          .required("PAN is required")
        : Yup.string(),
      phone: Yup.string()
        .required("Please Enter Mobile Number")
        .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
      address: Yup.string().required("Address is required"),
      city: Yup.string().required("City is required"),
      state: Yup.string().required("State is required"),
      pin: Yup.string().required("Pin is required"),
      UID: selectedId?.value == 'UID'
        ? Yup.string()
          .required("Please Enter UID Number")
          .matches(/^\d{12}$/, "UID Number must be exactly 12 digits")
        : Yup.string(),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const authPersonData = [
        selectedBureauForData
      ]
      let idValue = valueName[`${selectedId?.value}`]
      selectedBureauForData[`${idValue}`] = values[`${selectedId?.value}`]
      selectedBureauForData.mobile = values.phone
      selectedBureauForData.email = values.email
      const data = {
        FirstName: values.firstName,
        LastName: values.lastName,
        DOB: moment(values.dob),
        Phone1: values.phone,
        Email1: values.email,
        AddressLine1: values.address,
        Locality1: values.city,
        City1: values.city,
        State1: values.state,
        Pincode1: values.pin,
        Country1: 'india',
        Consent: "Y",
        authPersonId: selectedBureauForData.id,
        entityId: selectedBureauForData.entityId,
      }
      getUserConsent({ email:values.email }).then((response) => {
        if (response && response.status && response.data[0].userConsent) {
          if (response.data[0].userConsent) {
            data[`${selectedId?.value}`] = values[`${selectedId?.value}`]
            getCrifReport(data).then((response) => {
              setLoading(false);
              if (response.status) {
                downloadDealDetailsPdf(response.pdfData)
                editAuthorisedPerson(authPersonData)
                  .then((response) => {
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                addCrifReport(response.crifLogs).then((response) => {
                  if ((response.code == 201 && response.status)) {
                    callCrifReportList()
                  }
                })
                  .catch((error) => {
                    console.log(error);
                  });
              } else if (response?.message?.getCrifresponseStage2 && response?.message?.getCrifresponseStage2.status == 'S11') {
                setQuestion(response?.message?.getCrifresponseStage2.question)
                setOptionsList(response?.message?.getCrifresponseStage2.optionsList)
                setResponseBody(response?.message)
                setSubscribemodal(true)
              } else {
                setToastInfo({
                  message: response?.error?.message || response?.message || 'Something Went Wrong!!',
                  showToast: true,
                  role: "error",
                });
              }
            })
              .catch((error) => {
                setLoading(false);
              })
          }
        } else {
          setLoading(false);
          let userData = {
            email: values.email,
            firstName: values.firstName,
            lastName: values.lastName,
            mobileNo: values.phone,
            entityId: selectedBureauForData.entityId,
            roleId: 2
          }
          let message = 'The consent to fetch the Bureau for this user is either not received or expired. Click the button below to send an email to request consent'
          if (response?.data) {
            message = 'The consent to fetch the Bureau for this user is either not received or expired. Please login and give the consent'
            setShowCommonDialog2({ isShow: true, message })
          } else {
            setShowCommonDialog({ isShow: true, message, userData })
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
  });

  const validationTypeCompany = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: entityDetail?.entityName || "",
      pan: entityDetail?.pan || "",
      gstin: entityDetail?.gstnIn || "",
      phone: "",
      address: "",
      state: "",
      pincode: "",
      city: ""
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Entity Name is required"),
      state: Yup.string().required("State is required"),
      pincode: Yup.string().required("Pincode is required"),
      city: Yup.string().required("City is required"),
      address: Yup.string()
      .trim() // Removes leading and trailing spaces
      .required("Address is required")
      .test('not-only-spaces', 'Address cannot be empty or just spaces', (value) => {
        return value && value.trim().length > 0; // Ensure value isn't just spaces
      }),
      gstin: Yup.string().required("Please Enter GSTIN")
        .test("gstnCheck", "Enter correct GSTIN!", (value) => {
          if (value && value.length > 0) {
            const isGstinValid = Yup.string()
              .matches(API_SERVICES.GSTN_PATTERN, "Enter correct GSTIN!")
              .isValidSync(value);

            return isGstinValid;
          }

          return true;
        })
        .test("panCheck", "GSTIN & PAN mismatch", (value, { parent }) => {
          if (value?.length > 0) {
            const pan = value.substring(2, 12);
            return pan === parent.pan || !parent.pan;
          }

          return true;
        }),
      phone: Yup.string().required("Please Mobile Number").matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
      pan: Yup.string().required("Please Enter PAN").matches(API_SERVICES.PAN_PATTERN, "Enter a valid PAN number"),
    }),
    onSubmit: async (values) => {
      setLoadingCom(true);
      let body = {
        ...values,
        entityId,
      }
      let data = await getCrifReportCommercial(body)
      if (data.status) {
        setLoadingCom(false)
        setToastInfo({
          message: data.message,
          showToast: true,
          role: "success",
        });
      } else {
        setLoadingCom(false)
        setToastInfo({
          message: data.message,
          showToast: true,
          role: "error",
        });
      }
    },
  });

  const onGSTINChange = useAsyncDebounce((value) => {
    if (!validationTypeCompany.errors.gstin) findGSTINDetails(value);
  }, 400);

  const findGSTINDetails = (gstin) => {
    setGSTINSerching(true);
    callGetGSTINDetails({ gstnIn: gstin })
      .then((result) => {
        if (result.code == 200 && result.status) {
          const { data: gstinDetails } = result;
          const { tradeNam } = gstinDetails;
          const { stcd, dst, pncd, bnm, flno, landMark } = gstinDetails.pradr.addr;
          validationTypeCompany.setFieldValue('name', tradeNam)
          validationTypeCompany.setFieldValue('pincode', pncd)
          let address = (bnm || '') + ' ' + (flno || '') + ' ' + ' ' + (landMark || '')
          validationTypeCompany.setFieldValue("address", address);
          if (stateList && stcd) {
            let val = setStateValueWithCode(stateList, stcd.toUpperCase())
            setSelectedState(val)
            getCityList(stcd)
            validationTypeCompany.setFieldValue("state", val.value);
          }
          if (cityList && dst) {
            const value = { label: dst.toUpperCase(), value: dst.toUpperCase() };
            setCityForCompany(value)
            validationTypeCompany.setFieldValue("city", dst.toUpperCase());
          }
          validationTypeCompany.setFieldValue("pan", gstin.substring(2, 12));
        } else {
          setToastInfo({
            message: "Incorrect GSTIN",
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "GSTIN not found",
          showToast: true,
          role: "error",
        });
      })
      .finally((f) => {
        setGSTINSerching(false);
      });
  };

  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
    callCrifReportList()
  };

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  };

  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "", "id", "desc");
  };

  const handleSortColumn = (option) => {
    setTableSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc"
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const deleteITRRecord = () => {
    setDeleteDialog(false);

    const postParams = {
      id: dialogObj?.id,
    };

    deleteCrifReportList(postParams)
      .then((response) => {
        if (response.code == 201 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          callCrifReportList()
          setDialogObj(null);
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setAuthPersonData = (data) => {
    setSelectedBureauForData(data);
    getPersonAddress({ personId: data.id })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setAddress(response.data)
          getCityList(response.data[0]?.state)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  function setStateValue(data, state) {
    if (state) {
      for (const item of data) {
        if (item.name === state) {
          const value = { label: `${item.name}`, value: state };
          return value;
        }
      }
    }
  }

  function setStateValueWithCode(data, state) {
    if (state) {
      for (const item of data) {
        if (item.name === state) {
          const value = { label: `${item.name}`, value: item.abbreviation };
          return value;
        }
      }
    }
  }

  const getCityList = (value) => {
    callGetCity({ state: value })
      .then((response) => {
        if (response.status) {
          setCityList(response?.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleInputChange = (value) => {
    validationTypePartner.setFieldValue("state", value);
    validationTypePartner.setFieldValue("city", "")
    getCityList(value)
  };

  const handleInputChangeForCommercial = (value) => {
    validationTypeCompany.setFieldValue("city", "")
    getCityList(value)
  };

  const handleCityChange = (value) => {
    validationTypePartner.setFieldValue("city", value);
  };

  const handleCityChangeForCompany = (value) => {
    validationTypeCompany.setFieldValue("city", value);
  };

  const handleOptionChange = (value) => {
    validation2.setFieldValue("userAns", value);
  };

  function setCityValue(data, city) {
    if (city) {
      for (const item of data) {
        if (item.cityName === city) {
          const value = { label: `${item.cityName}`, value: city };
          return value;
        }
      }
    } else {
      return null
    }
  }

  const handleToast = (info) => {
    setToastInfo(info);
  };

  const downloadDealDetailsPdf = (data) => {
    setToastInfo({
      message: 'Downloading please wait...',
      showToast: true,
      role: "success",
    })
    let source = `data:application/pdf;base64,${data}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = 'Crif.pdf'
    link.click();
    setToastInfo({
      message: 'Downloaded Successfully',
      showToast: true,
      role: "success",
    })
  }

  const validation2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      userAns: ''
    },
    validationSchema: Yup.object({
      userAns: Yup.string().required("Please select option"),
    }),
    onSubmit: values => {
      setAnsSubmitting(true)
      const authPersonData = [
        selectedBureauForData
      ]
      responseBody.stage2ReplacementData.userAns = values.userAns
      responseBody.authPersonId = selectedBureauForData.id
      responseBody.entityId = selectedBureauForData.entityId
      stage2Question(responseBody).then((response) => {
        if (response.status) {
          setSubscribemodal(false)
          setAnsSubmitting(false)
          downloadDealDetailsPdf(response.pdfData)
          editAuthorisedPerson(authPersonData)
            .then((response) => {
            })
            .catch((error) => {
              console.log(error);
            });
          addCrifReport(response.crifLogs).then((response) => {
            if ((response.code == 201 && response.status)) {
              callCrifReportList()
            }
          })
            .catch((error) => {
              console.log(error);
            });
        } else if (response?.message?.getCrifresponseStage2 && response?.message?.getCrifresponseStage2.status == 'S11') {
          setAnsSubmitting(false)
          setQuestion(response?.message?.getCrifresponseStage2.question)
          setOptionsList(response?.message?.getCrifresponseStage2.optionsList)
          setResponseBody(response?.message)
        } else if (response?.message?.getCrifresponseStage2 && response?.message?.getCrifresponseStage2.status == 'S02') {
          setAnsSubmitting(false)
          setSubscribemodal(false)
          setToastInfo({
            message: response?.message?.getCrifresponseStage2.statusDesc || 'Something Went Wrong!!',
            showToast: true,
            role: "error",
          });
        } else {
          setAnsSubmitting(false)
          setSubscribemodal(false)
          setToastInfo({
            message: response?.error?.message || response?.message || 'Something Went Wrong!!',
            showToast: true,
            role: "error",
          });
        }
        validation2.resetForm()
      }).catch((error) => {
        setAnsSubmitting(false)
        setSubscribemodal(false)
        validation2.resetForm()
        setToastInfo({
          message: error?.message || 'Something Went Wrong!!',
          showToast: true,
          role: "error",
        });
      })
    }
  })

  const checkPermissions = async () => {
    const isPermissions = await isPermission(
      "req_consent",
      "create_permission"
    );
    seIisUserConsentPermission(isPermissions)
  };

  const dialogAction = (action, data) => {
    if (action == 1) {
      addUser(data)
        .then((response) => {
          if (response.status) {
            setToastInfo({
              message: "Consent mail sent!",
              showToast: true,
              role: "success",
            })
          } else {
            const { message } = response;
            setToastInfo({
              message: 'Error while sending mail!',
              showToast: true,
              role: "error",
            });
          }
          setShowCommonDialog({ isShow: false })
        })
        .catch((error) => {
          console.log(error)
          setShowCommonDialog({ isShow: false })
        })
    } else {
      setShowCommonDialog({ isShow: false })
    }
  }

  const dialogAction2 = (action, data) => {
    setShowCommonDialog2({ isShow: false })
  }
  return (
    <Fragment>
      <div className="row">
        <Col sm="12" md="6" className="mb-3">
          <Label>Bureau For</Label>
          <Select
            value={selectedBureauFor}
            onChange={(e) => {
              setSelectedBureauFor(e);
              if (e.value === 'Commercial') {
                if (entityDetail && entityDetail.gstnIn) {
                  findGSTINDetails(entityDetail.gstnIn)
                }
              }
            }}
            options={bureauForOptions}
          />
        </Col>
  
        {selectedBureauFor?.value == 'Individual' && (<Col sm="12" md="6" className="mb-3">
          <Label>Applicant Name</Label>
          <Select
            value={selectedAuthPerson}
            onChange={(e) => {
              setSelectedAuthPerson(e);
              setAuthPersonData(e.data)
            }}
            options={authPersonList?.map((o) => {
              return { label: o?.firstName + ' ' + o?.lastName, value: o?.id, data: o };
            })}
          />
        </Col>)}
        <Col xl="12">
          {selectedBureauFor?.value == 'Individual' &&
            !view &&
            (
              <Form
                className="needs-validation"
                onSubmit={(e) => {
                  e.preventDefault();
                  validationTypePartner.handleSubmit();
                  return false;
                }}
              >
                <div className="row">
                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">
                        First Name *
                      </Label>
                      <Input
                        name="firstName"
                        placeholder="Enter Applicant First Name"
                        type="text"
                        className="form-control"
                        id="validationApplicantName"
                        onChange={validationTypePartner.handleChange}
                        onBlur={validationTypePartner.handleBlur}
                        value={validationTypePartner.values.firstName || ""}
                        invalid={
                          validationTypePartner.touched.firstName &&
                          validationTypePartner.errors.firstName
                        }
                      // disabled={validationTypePartner.values.firstName}
                      />

                      {validationTypePartner.touched.firstName &&
                        validationTypePartner.errors.firstName ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.firstName}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">
                        Last Name *
                      </Label>
                      <Input
                        name="lastName"
                        placeholder="Enter Applicant Last Name"
                        type="text"
                        className="form-control"
                        id="validationApplicantName"
                        onChange={validationTypePartner.handleChange}
                        onBlur={validationTypePartner.handleBlur}
                        value={validationTypePartner.values.lastName || ""}
                        invalid={
                          validationTypePartner.touched.lastName &&
                          validationTypePartner.errors.lastName
                        }
                      // disabled={validationTypePartner.values.lastName}
                      />

                      {validationTypePartner.touched.lastName &&
                        validationTypePartner.errors.lastName ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.lastName}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">Email *</Label>
                      <Input
                        name="email"
                        placeholder="Enter Email"
                        type="email"
                        className="form-control"
                        id="validationEmail"
                        onChange={validationTypePartner.handleChange}
                        onBlur={validationTypePartner.handleBlur}
                        value={validationTypePartner.values.email || ""}
                        invalid={
                          validationTypePartner.touched.email &&
                          validationTypePartner.errors.email
                        }
                      // disabled={validationTypePartner.values.email}
                      />

                      {validationTypePartner.touched.email &&
                        validationTypePartner.errors.email ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">Phone *</Label>
                      <Input
                        name="phone"
                        placeholder="Enter Phone"
                        type="text"
                        className="form-control"
                        id="validationPhone"
                        onChange={validationTypePartner.handleChange}
                        onBlur={validationTypePartner.handleBlur}
                        value={validationTypePartner.values.phone || ""}
                        invalid={
                          validationTypePartner.touched.phone &&
                          validationTypePartner.errors.phone
                        }
                      // disabled={validationTypePartner.values.phone}
                      />

                      {validationTypePartner.touched.phone &&
                        validationTypePartner.errors.phone ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.phone}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">Select Id *</Label>
                      <Select
                        className={`select-dropdown ${validationTypePartner.touched.identy &&
                          validationTypePartner.errors.identy
                          ? "is-invalid"
                          : ""
                          }`}
                        id="validationIdenty"
                        value={selectedId}
                        onChange={(e) => {
                          setSelectedId(e);
                          validationTypePartner.setFieldValue(
                            "identy",
                            e.value
                          );
                        }}
                        isLoading={false}
                        options={idList}
                      // isDisabled={validationTypePartner.values.identy}
                      />
                      {validationTypePartner.touched.identy &&
                        validationTypePartner.errors.identy ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.identy}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  {selectedId && (
                    <Col sm="12" md="6">
                      <div className="mb-3">
                        <Label className="form-label mt-2">{selectedId.value} *</Label>
                        <Input
                          name={selectedId.value}
                          type="text"
                          placeholder={`Insert ${selectedId.value}`}
                          onChange={validationTypePartner.handleChange}
                          onBlur={validationTypePartner.handleBlur}
                          value={validationTypePartner.values[`${selectedId?.value}`] || ""}
                          invalid={
                            validationTypePartner.touched[`${selectedId?.value}`] &&
                            validationTypePartner.errors[`${selectedId?.value}`]
                          }
                        // disabled={validationTypePartner.values.selectedId.value}
                        />
                        {validationTypePartner.touched[`${selectedId?.value}`] &&
                          validationTypePartner.errors[`${selectedId?.value}`] ? (
                          <FormFeedback type="invalid">
                            {validationTypePartner.errors[`${selectedId?.value}`]}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  )}

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">Date of Birth *</Label>
                      <Input
                        name="dob"
                        type="date"
                        onChange={validationTypePartner.handleChange}
                        onBlur={validationTypePartner.handleBlur}
                        value={validationTypePartner.values.dob || ""}
                        invalid={
                          validationTypePartner.touched.dob &&
                          validationTypePartner.errors.dob
                        }
                        max={currentDate}
                      // disabled={validationTypePartner.values.dob}
                      />
                      {validationTypePartner.touched.dob &&
                        validationTypePartner.errors.dob ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.dob}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">Address *</Label>
                      <Input
                        name="address"
                        placeholder="Enter Address"
                        type="text"
                        className="form-control"
                        id="validationAddress"
                        onChange={validationTypePartner.handleChange}
                        onBlur={validationTypePartner.handleBlur}
                        value={validationTypePartner.values.address || ""}
                        invalid={
                          validationTypePartner.touched.address &&
                          validationTypePartner.errors.address
                        }
                      />

                      {validationTypePartner.touched.address &&
                        validationTypePartner.errors.address ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.address}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">State*</Label>
                      <Select
                        options={stateList.map((option, index) => ({
                          label: option.name,
                          value: option.name,
                        }))}
                        className={`select-dropdown ${validationTypePartner.touched.state && validationTypePartner.errors.state
                          ? "is-invalid"
                          : ""
                          }`}
                        name="state"
                        id="state"
                        onChange={(selectedOption) => {
                          handleInputChange(selectedOption.value);
                        }}
                        value={setStateValue(
                          stateList,
                          validationTypePartner.values.state
                        )}
                      />
                      {validationTypePartner.touched.state &&
                        validationTypePartner.errors.state && (
                          <FormFeedback>
                            {validationTypePartner.errors.state}
                          </FormFeedback>
                        )}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">City*</Label>
                      <Select
                        options={cityList.map((option) => ({
                          label: option.cityName,
                          value: option.cityName,
                        }))}
                        className={`select-dropdown ${validationTypePartner.touched.city && validationTypePartner.errors.city
                          ? "is-invalid"
                          : ""
                          }`}
                        name="city"
                        id="city"
                        onChange={(selectedOption) => {
                          handleCityChange(selectedOption.value);
                        }}
                        value={setCityValue(
                          cityList,
                          validationTypePartner.values.city
                        )}
                      />
                      {validationTypePartner.touched.city && validationTypePartner.errors.city ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.city}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col sm="12" md="6">
                    <div className="mb-3">
                      <Label className="form-label mt-2">PIN*</Label>
                      <Input
                        name="pin"
                        placeholder="Enter PIN"
                        type="text"
                        className="form-control"
                        id="validationPin"
                        onChange={validationTypePartner.handleChange}
                        onBlur={validationTypePartner.handleBlur}
                        value={validationTypePartner.values.pin || ""}
                        invalid={
                          validationTypePartner.touched.pin &&
                          validationTypePartner.errors.pin
                        }
                      />
                      {validationTypePartner.touched.pin &&
                        validationTypePartner.errors.pin ? (
                        <FormFeedback type="invalid">
                          {validationTypePartner.errors.pin}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col
                    xl="12"
                    className="d-flex justify-content-end mb-4"
                  >
                    <button
                      type="submit"
                      className="btn btn-success save-customer"
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2 me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      {loading && <span>Saving</span>}
                      {!loading && <span>Save</span>}
                    </button>
                  </Col>
                </div>
              </Form>
            )}
          {selectedBureauFor?.value == 'Commercial' &&
            !view &&
            (
              <Form
                className="needs-validation"
                onSubmit={(e) => {
                  e.preventDefault();
                  validationTypeCompany.handleSubmit();
                  return false;
                }}
              >
              <div className="row">
                <Col sm="12" md="6">
                  <Label className="form-label mt-2">GSTIN*</Label>
                  <Input
                    name="gstin"
                    type="text"
                    placeholder="Enter GSTIN"
                    onChange={(e) => {
                      validationTypeCompany.handleChange(e);
                      onGSTINChange(e.target.value);
                    }}
                    onBlur={validationTypeCompany.handleBlur}
                    value={validationTypeCompany.values.gstin || ""}
                    invalid={
                      validationTypeCompany.touched.gstin &&
                      validationTypeCompany.errors.gstin
                    }
                    disabled={isGSTINSerching}
                  />
                  {isGSTINSerching && (
                    <div
                      className="spinner-border progress-load"
                      role="status"
                      style={{
                        top: "10px",
                        width: "1rem",
                        height: "1rem",
                        "border-width": "0.2em",
                      }}
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                  {validationTypeCompany.touched.gstin &&
                    validationTypeCompany.errors.gstin ? (
                    <FormFeedback type="invalid">
                      {validationTypeCompany.errors.gstin}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-2">PAN*</Label>
                  <Input
                    name="pan"
                    type="text"
                    placeholder="Enter PAN"
                    onChange={validationTypeCompany.handleChange}
                    onBlur={validationTypeCompany.handleBlur}
                    value={validationTypeCompany.values.pan || ""}
                    invalid={
                      validationTypeCompany.touched.pan && validationTypeCompany.errors.pan
                    }
                  />
                  {validationTypeCompany.touched.pan && validationTypeCompany.errors.pan ? (
                    <FormFeedback type="invalid">
                      {validationTypeCompany.errors.pan}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-3">Entity Name*</Label>
                  <Input
                    name="name"
                    placeholder="Enter Name"
                    type="text"
                    className="form-control"
                    id="validationName"
                    onChange={validationTypeCompany.handleChange}
                    onBlur={validationTypeCompany.handleBlur}
                    value={validationTypeCompany.values.name || ""}
                    invalid={
                      validationTypeCompany.touched.name &&
                      validationTypeCompany.errors.name
                    }
                  />

                  {validationTypeCompany.touched.name &&
                    validationTypeCompany.errors.name ? (
                    <FormFeedback type="invalid">
                      {validationTypeCompany.errors.name}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-3">Mobile No*</Label>
                  <Input
                    name="phone"
                    placeholder="Enter Mobile No"
                    type="text"
                    className="form-control"
                    id="validationMobile"
                    onChange={validationTypeCompany.handleChange}
                    onBlur={validationTypeCompany.handleBlur}
                    value={validationTypeCompany.values.phone || ""}
                    invalid={
                      validationTypeCompany.touched.phone &&
                      validationTypeCompany.errors.phone
                    }
                  />

                  {validationTypeCompany.touched.phone &&
                    validationTypeCompany.errors.phone ? (
                    <FormFeedback type="invalid">
                      {validationTypeCompany.errors.phone}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-3">Address*</Label>
                  <Input
                    name="address"
                    placeholder="Enter Address"
                    type="text"
                    className="form-control"
                    id="validationAddress"
                    onChange={validationTypeCompany.handleChange}
                    onBlur={validationTypeCompany.handleBlur}
                    value={validationTypeCompany.values.address || ""}
                    invalid={
                      validationTypeCompany.touched.address &&
                      validationTypeCompany.errors.address
                    }
                  />

                  {validationTypeCompany.touched.address &&
                    validationTypeCompany.errors.address ? (
                    <FormFeedback type="invalid">
                      {validationTypeCompany.errors.address}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-3">State*</Label>
                  <Select
                    className={`select-dropdown ${validationTypeCompany.touched.state &&
                      validationTypeCompany.errors.state
                      ? "is-invalid"
                      : ""
                      }`}
                    id="validationState"
                    value={selectedState}
                    onChange={(e) => {
                      handleInputChangeForCommercial(e.label);
                      setSelectedState(e);
                      validationTypeCompany.setFieldValue("state", e.value);
                    }}
                    //   onKeyDown={(e) => {
                    //     bankValueChange(e.target.value);
                    //   }}
                    isLoading={false}
                    options={stateOptions?.map((i) => {
                      return { label: i?.name, value: i?.abbreviation };
                    })}
                  />
                  {validationTypeCompany.touched.state &&
                    validationTypeCompany.errors.state ? (
                    <FormFeedback type="invalid">
                      {validationTypeCompany.errors.state}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                  <Label className="form-label mt-3">City*</Label>
                  <Select
                    options={cityList.map((option) => ({
                      label: option.cityName,
                      value: option.cityName,
                    }))}
                    className={`select-dropdown ${validationTypeCompany.touched.city && validationTypeCompany.errors.city
                      ? "is-invalid"
                      : ""
                      }`}
                    name="city"
                    id="city"
                    onChange={(selectedOption) => {
                      handleCityChangeForCompany(selectedOption.value);
                    }}
                    // value={cityForCompany}
                    value={setCityValue(
                      cityList,
                      validationTypeCompany.values.city
                    )}
                    invalid={
                      validationTypeCompany.touched.city &&
                      validationTypeCompany.errors.city
                    }
                  />
                  {validationTypeCompany.touched.city && validationTypeCompany.errors.city ? (
                    <FormFeedback type="invalid">
                      {validationTypeCompany.errors.city}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="6">
                    <Label className="form-label mt-3">PIN*</Label>
                    <Input
                      name="pincode"
                      placeholder="Enter PIN"
                      type="text"
                      className="form-control"
                      id="validationPin"
                      onChange={validationTypeCompany.handleChange}
                      onBlur={validationTypeCompany.handleBlur}
                      value={validationTypeCompany.values.pincode || ""}
                      invalid={
                        validationTypeCompany.touched.pincode &&
                        validationTypeCompany.errors.pincode
                      }
                    />
                    {validationTypeCompany.touched.pincode &&
                      validationTypeCompany.errors.pincode ? (
                      <FormFeedback type="invalid">
                        {validationTypeCompany.errors.pincode}
                      </FormFeedback>
                    ) : null}
                </Col>
              
                <Col
                  xl="12"
                  className="d-flex justify-content-end mb-4 mt-3"
                >
                  <button
                    type="submit"
                    className="btn btn-success save-customer"
                    disabled={loadingCom}
                  >
                    {loadingCom && (
                      <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {loadingCom && <span>Saving</span>}
                    {!loadingCom && <span>Save</span>}
                  </button>
                </Col>
              </div>
              </Form>
            )}
          {view && (
            <div className="row">
              <Col xl="12" className="d-flex justify-content-center mb-4">
                <button
                  type="button"
                  className="btn btn-outline-danger save-customer me-2"
                  onClick={() => setView(false)}
                >
                  Cancel
                </button>
              </Col>

            </div>
          )}
        </Col>
      </div>

      <div className="row">
        <TableContainerV1
          columns={columns}
          data={tableData}
          pagination={pagination}
          handlePageChange={handlePageChange}
          handleSearchFilter={handleSearchFilter}
          sortOptions={tableSortingOptions}
          handleSortColumn={handleSortColumn}
          handleClearSearch={handleClearSearch}
          hidePageSize={true}
          hideSearchView={true}
          className="custom-header-css"
        />
      </div>
      <DeleteModal
        msg="Are you sure to delete record?"
        show={deleteDialog}
        onDeleteClick={deleteITRRecord}
        onCloseClick={() => setDeleteDialog(false)}
      />
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>

      <Modal
        isOpen={subscribemodal}
        role="<dialog>"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setSubscribemodal(!subscribemodal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setSubscribemodal(!subscribemodal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body vertical-scroll" style={{ height: "200px" }}>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validation2.handleSubmit()
              return false
            }}
          >
            <Col xl={12} >
              <div className="mb-3">
                <Label className="form-label mb-2">{question}</Label>
                <Select
                  options={optionsList.map((option) => ({
                    label: option,
                    value: option,
                  }))}
                  className={`select-dropdown ${validation2.touched.userAns && validation2.errors.userAns
                    ? "is-invalid"
                    : ""
                    }`}
                  name="userAns"
                  id="userAns"
                  onChange={(selectedOption) => {
                    handleOptionChange(selectedOption.value);
                  }}
                  value={
                    { value: validation2.values.userAns, label: validation2.values.userAns }
                  }
                />
                {validation2.touched.userAns && validation2.errors.userAns ? (
                  <FormFeedback type="invalid">
                    {validation2.errors.userAns}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
            <Row>
              <Col sm="12" >
                <div className="d-flex gap-3 justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-success save-customer mt-2"
                  >
                    {ansSubmitting && (
                      <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {ansSubmitting && <span>Submitting</span>}
                    {!ansSubmitting && <span>Submit</span>}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      {showCommonDialog && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message}
          data={showCommonDialog.userData}
          postitiveBtn={"Send"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        ></CommonDialog>
      )}
        {showCommonDialog2 && (
        <CommonDialog
          isShow={showCommonDialog2.isShow}
          message={showCommonDialog2.message}
          data={showCommonDialog2.data}
          postitiveBtn={"Ok"}
          // negativeBtn={"Close"}
          onCloseFn={dialogAction2}
        ></CommonDialog>
      )}
    </Fragment>
  );
};

export default CreditVerification;


function formatFunction(file, showToastCallback) {
  const str = file.substring(file.indexOf("com") + 4);
  const filename = file.substring(file.lastIndexOf("/") + 1);
  const ext = str.split(".").pop();
  const obj = {
    fileName: str,
  };

  downloadSystemConfigFile(obj)
    .then((response) => {
      if (response.code === 200) {
        downloadFile(response.result, ext, filename);
        showToastCallback({
          message: 'Downloaded successfully',
          showToast: true,
          role: "success",
        });
      } else {
        showToastCallback({
          message: response.message,
          showToast: true,
          role: "error",
        });
      }
    })
    .catch((error) => {
    });
}

function downloadFile(base64String, ext, fileName) {
  let source = "";
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();

  }
}


